import Label from '../../../../ui/label';
import { useDispatch } from 'react-redux';
import LoadingCategory from '../../../../ui/loading-category';
import ErrorFetch from '../../../../ui/error-fetch-category';
import SubTypeOptionBox from './sub-type-option-box';
import OthersInput from '../../../../ui/others-input';
import { FlowbiteUsersGroupSolid } from '../../../../../assets/icon/iconify';
import { useMediaQuery } from '../../../../../hooks/common/use-media-query';
import { useIsCompleteProposalAs } from '../../../../../hooks/proposal/use-state-checker-proposal';
import { useQueries } from '../../../../../hooks/services/queries/use-queries';
import { setOtherSpecificationToG, setTypeOfGroup } from '../../../../../features/gms-proposal-forms/gc-tog-ea-mop/gc-tog-ea-mop-slice';
import { SubTypeOption } from '../../../../../api/gms/group-category/group-category-api-state';
import Checkbox from '../../../../ui/checkbox';
import { useProposalTypeData } from '../../../../../hooks/proposal/use-proposal-type-data';

export default function ClientInputTypeOfGroup() {

    const dispatch = useDispatch();
    const { 
        typeOfGroup, 
        isLoadingTypeOfGroup, 
        isErrorTypeOfGroup, 
        isFetchingTypeOfGroup 
    } = useQueries();
    const {
        othersTypeOfGroupValue,
        typeOfGroup: selectedTypeOfGroup,
        hasOtherToG,
    } = useProposalTypeData()
    const isDesktop = useMediaQuery("(min-width: 1024px)");
    const iconSize: number = isDesktop ? 16 : 15;
    const isComplete = useIsCompleteProposalAs();

    const handleBusinessTypeChange = (e: React.ChangeEvent<HTMLInputElement>, option: SubTypeOption) => {
        dispatch(setTypeOfGroup(option));
    };

    const handleOtherSpecificationChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(setOtherSpecificationToG(e.target.value));
    };

    const mappedOptions: SubTypeOption[] =
        typeOfGroup?.map(item => ({
            id: item.id,
            name: item.name,
            isActive: item.is_active
        })) || [];

    const selectedParent = typeOfGroup?.find(item => item.id === selectedTypeOfGroup?.id);

    const currentSubTypeOptions: SubTypeOption[] =
        selectedParent?.children?.map(child => ({
            id: child.id,
            name: child.name,
            isActive: child.is_active
        })) || [];

    return (
        <div className="border border-gray-200 space-y-2 col-span-1 rounded bg-white p-3.5 md:p-4">
            <div className="space-y-2">
                <div>
                    <div className="flex space-x-2 items-center mb-1">
                        <div className="bg-[#186db233] p-1 rounded">
                            <FlowbiteUsersGroupSolid width={iconSize} height={iconSize} />
                        </div>
                        <Label
                            label="Type of Group"
                            fontWeight="font-semibold text-gray-800"
                            fontSize="text-xs"
                            requiredText=" *"
                            isRequired={true}
                        />
                    </div>
                    <div className="grid grid-cols-1 gap-2">
                        {isLoadingTypeOfGroup || isFetchingTypeOfGroup ? (
                            <LoadingCategory />
                        ) : isErrorTypeOfGroup ? (
                            <ErrorFetch />
                        ) : (
                            mappedOptions.map(option => {
                                const isSelected = selectedTypeOfGroup?.id === option.id;
                                const isDisabled = !isComplete || option.isActive === false;
                                return (
                                    <div key={option.id}>
                                        <Checkbox
                                            disabled={isDisabled} 
                                            option={option} 
                                            isSelected={isSelected} 
                                            onChange={handleBusinessTypeChange}
                                        />
                                        <SubTypeOptionBox
                                            optionId={option.id}
                                            currentSubTypeOptions={currentSubTypeOptions}
                                        />
                                        <OthersInput
                                            optionId={option.id}
                                            value={othersTypeOfGroupValue ?? ""}
                                            onChange={handleOtherSpecificationChange}
                                            isShowInput={hasOtherToG}
                                        />
                                    </div>
                                );
                            })
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}